import { t } from "./i18n";

export function auditActionLabel(action: string): string {
  const key = `audit.actions.${action}`;
  const localized = t(key, "");
  return localized || action;
}

export function auditActorTypeLabel(actorType: string | null | undefined): string {
  if (!actorType) return "—";
  const key = `audit.actorType.${actorType}`;
  const localized = t(key, "");
  return localized || actorType;
}

export function auditTargetTypeLabel(targetType: string | null | undefined): string {
  if (!targetType) return "—";
  const key = `audit.targetType.${targetType}`;
  const localized = t(key, "");
  return localized || targetType;
}
